
import { useState, useEffect } from 'react';

import ReportShort from './ReportShort';
import LeadForm from './LeadForm';

import { useAppContext } from "@src/contexts/App/AppContext";

import { Trans, t } from '@lingui/macro';

const PopUpContent = () => {

    const [appState, AppActions] = useAppContext();

    let content = null;

    useEffect(() => {

        if (appState.showThx) {
            try {
                
                gtag('event', "lending_lead", {
                    'event_category': "partners",
                });
                
                fbq('track', 'Lead');

                console.log("Trigger:lending_lead");
            } catch (error) {
                console.log(error);
            }
        }

    }, [appState.showThx]);

    if (appState.showThx) {
        content = (
            <div className='text-center fw-bold my-md-4'>

                <div className='row mb-3'>
                    <div className='col-md-4 offset-md-4'>
                        <img src={co2_form_info.bundlesUrl + "static/images/logo.png"} alt="Logo" className='img-fluid' />
                    </div>
                </div>

                <div className='fs-3 mb-2'>
                    <Trans>
                        Grazie per la tua richiesta!
                    </Trans>
                </div>
                <div className='fs-1 mb-2 text-primary'>
                    <Trans>
                        ti contatteremo al più presto
                    </Trans>
                </div>
            </div>
        )
    } else {

        content = (
            <>
                <div className='mb-2'>
                    <ReportShort />
                </div>
                <div>
                    <LeadForm />
                </div>
            </>
        );

    }

    return (
        <div className='px-md-4'>
            {content}
        </div>
    );
}

export default PopUpContent;
